import svg_bg_p2 from "../../assets/gallery/digitals/svg_bg_p2.svg";
import game_night from "../../assets/gallery/digitals/game_night.png";
import spring_celeb from "../../assets/gallery/digitals/spring_celeb.png";
import mismorize from "../../assets/gallery/digitals/mismorize.gif";
import dice from "../../assets/gallery/digitals/dice.gif";
import chess from "../../assets/gallery/digitals/chess.png";
import svg_prototype from "../../assets/gallery/digitals/svg_prototype.svg";
import svg_bg_p6e from "../../assets/gallery/digitals/svg_bg_p6e.svg";
import svg_bg_p6b from "../../assets/gallery/digitals/svg_bg_p6b.svg";
import hw2_creative_design from "../../assets/gallery/digitals/hw2_creative_design.png";
import rotation from "../../assets/gallery/digitals/rotation.gif";
import spring_poster from "../../assets/gallery/digitals/spring_poster.png";
import latern_poster from "../../assets/gallery/digitals/latern_poster.png";
import chiny from "../../assets/gallery/digitals/chiny.png";
import heart from "../../assets/gallery/digitals/heart.svg";

const DataDigitals = [
	{src:svg_bg_p2, name:svg_bg_p2},
	{src:game_night, name:game_night},
	{src:spring_celeb, name:spring_celeb},
	{src:mismorize, name:mismorize},
	{src:dice, name:dice},
	{src:chess, name:chess},
	{src:svg_prototype, name:svg_prototype},
	{src:svg_bg_p6e, name:svg_bg_p6e},
	{src:svg_bg_p6b, name:svg_bg_p6b},
	{src:hw2_creative_design, name:hw2_creative_design},
	{src:rotation, name:rotation},
	{src:spring_poster, name:spring_poster},
	{src:latern_poster, name:latern_poster},
	{src:chiny, name:chiny},
	{src:heart, name:heart},
]

export default DataDigitals;